import "regenerator-runtime/runtime";
import _asyncToGenerator from "/data/landun/workspace/vft-activities/d2d-welfare/codebase/node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator.js";
import Avatar from '@tencent/vft-ui/src/Avatar/Avatar.vue';
import AccountType from '@tencent/vft-ui/src/AccountType/AccountType.vue';
import EggInfo from '@/components/EggInfo/EggInfo';
import StrategyModule from '@/components/StrategyModule/StrategyModule.vue';
import MissionModule from '@/components/MissionModule/MissionModule.vue';
import RecordModule from '@/components/RecordModule/RecordModule.vue';
import Rule from '@/components/Rule/Rule';
import globalSetting from '@/setting';
export default {
  data: function data() {
    return {
      ruleVisible: false
    };
  },
  components: {
    Rule: Rule,
    Avatar: Avatar,
    AccountType: AccountType,
    EggInfo: EggInfo,
    StrategyModule: StrategyModule,
    MissionModule: MissionModule,
    RecordModule: RecordModule
  },
  computed: {
    backgroundImage: function backgroundImage() {
      return window.setting.背景图;
    },
    showFloatBtn: function showFloatBtn() {
      return globalSetting.展示悬浮按钮;
    },
    floatBtn: function floatBtn() {
      return globalSetting.悬浮按钮;
    }
  },
  created: function () {
    var _created = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var _this$userInfo, headurl, nick;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (this.isLogin) {
                _this$userInfo = this.userInfo, headurl = _this$userInfo.headurl, nick = _this$userInfo.nick;
                this.headurl = headurl;
                this.nick = nick;
              }

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function created() {
      return _created.apply(this, arguments);
    }

    return created;
  }(),
  methods: {
    clickFloatBtn: function clickFloatBtn() {
      this.openUrl(globalSetting.悬浮按钮跳转链接);
    }
  }
};